const mediaItems = [
  {
    title: '《长安十二时辰之风起云涌》幕后特辑',
    desc: '走进剧组拍摄现场，揭秘盛唐场景如何打造，服化道团队背后的匠心故事。',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20Chinese%20historical%20drama%20film%20set%2C%20director%20and%20crew%20working%20on%20ancient%20palace%20set%2C%20professional%20camera%20equipment%2C%20warm%20cinematic%20lighting%2C%20authentic%20production%20atmosphere%2C%20documentary%20style%20photography&width=800&height=500&seq=media-01-bts&orientation=landscape',
    duration: '15:28',
    tag: '幕后花絮',
  },
  {
    title: '《暗夜追光》主创深度访谈',
    desc: '导演与编剧畅谈创作历程，分享剧本打磨的幕后故事和角色塑造的心得体会。',
    img: 'https://readdy.ai/api/search-image?query=Film%20director%20and%20writer%20interview%20scene%2C%20modern%20studio%20setting%20with%20warm%20professional%20lighting%2C%20creative%20discussion%20atmosphere%2C%20cinematic%20documentary%20style%2C%20comfortable%20interview%20setup%2C%20high%20quality%20production&width=800&height=500&seq=media-02-interview&orientation=landscape',
    duration: '22:10',
    tag: '主创访谈',
  },
  {
    title: '《山海情缘》拍摄地风光纪实',
    desc: '跟随镜头探访宁夏取景地，感受山海之间壮美风光与剧中人物的真实生活场景。',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20rural%20mountain%20and%20coastal%20landscape%20documentary%20scene%2C%20Ningxia%20terraced%20fields%20and%20village%20in%20golden%20sunset%20light%2C%20natural%20scenic%20beauty%2C%20cinematic%20travel%20photography%2C%20warm%20atmospheric%20lighting&width=800&height=500&seq=media-03-scenery&orientation=landscape',
    duration: '18:45',
    tag: '取景纪实',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">精彩花絮</h2>
          <p className="text-sm text-foreground-500">幕后故事与独家内容，带你了解更多精彩</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#updates"
              className="group block bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-950/60 group-hover:bg-primary-500/80 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md text-xs font-medium bg-background-950/70 text-background-50 whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md text-xs font-medium bg-primary-500/90 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}